import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import CustomButton from './CustomButton';
import passcodeDialogStyles from './../../styles/passcodeDialogStyles';
import Services from '../../services/services';
import {
  getUserBrowserStorage,
  setUserBrowserStorage,
  watchAsGuestTermsText,
} from '../../constants';

import { useDispatch, useSelector } from 'react-redux';
import {
  updateEmailAndName,
  updateEventSeatInfo,
  clearForm,
  clearEventId,
} from '../../redux/eventAsGuestSlice';
import Loader from '../Loader';
import TermsContainer from '../loginPage/TermsContainer';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { isEmail, isAlphabet } from '../../regexFuncs';
import TextFieldComp from '../TextFieldComp';
import ArrowRightAltSharpIcon from '@material-ui/icons/ArrowRightAltSharp';
import toast from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => passcodeDialogStyles(theme));

export default function PasscodeFlowDialog({ eventId, eventUniqueNo }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const eventAsGuest = useSelector((state) => state.eventAsGuest);
  const userDetails = JSON.parse(getUserBrowserStorage('userDetails'));

  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (eventAsGuest.eventUniqueNo && open) {
      sharedEventCall();
    }
  }, [eventAsGuest.eventUniqueNo, open]);

  useEffect(() => {
    return () => {
      handleClose();
    };
  }, []);

  useEffect(() => {
    if (userDetails?.email && open) {
      const firstName = userDetails?.firstName;
      const lastName = userDetails?.lastName;
      const participantName = firstName + (lastName ? ' ' + lastName : '');
      onChangeHandle({
        target: { name: 'name', value: participantName, ignoreLen: true },
      });
      onChangeHandle({ target: { name: 'email', value: userDetails?.email } });
    }
  }, [open]);

  const onChangeHandle = (e) => {
    const value = e.target.value || '';
    const name = e.target.name;

    if (name === 'name') {
      if (value === '' || isAlphabet(value)) {
        if (value.length <= 16 || e.target?.ignoreLen) {
          dispatch(
            updateEmailAndName({
              [name]: { error: false, helpertext: ' ', value: value },
            })
          );
          return;
        }
        return;
      }
      return;
    } else if (name === 'email') {
      dispatch(
        updateEmailAndName({
          [name]: { error: false, helpertext: ' ', value: value.trim() },
        })
      );
      return;
    }

    dispatch(
      updateEmailAndName({
        [name]: { error: false, helpertext: ' ', value: value },
      })
    );
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    dispatch(clearForm({}));
    setOpen(false);
  };

  const validationFunc = () => {
    let errors = {};

    if (!eventAsGuest.name.value) {
      errors.name = 'Full name is required';
      const name = 'name';
      dispatch(
        updateEmailAndName({
          [name]: {
            value: '',
            error: true,
            helpertext: 'Full name is required',
          },
        })
      );
    }
    if (!eventAsGuest.email.value) {
      errors.email = 'Email address is required';
      const name = 'email';
      dispatch(
        updateEmailAndName({
          [name]: {
            value: '',
            error: true,
            helpertext: 'Email address is required',
          },
        })
      );
    } else if (!isEmail(eventAsGuest.email.value)) {
      errors.email = 'Email address is not valid';
      const name = 'email';
      dispatch(
        updateEmailAndName({
          [name]: {
            value: eventAsGuest.email.value,
            error: true,
            helpertext: 'Email address is not valid',
          },
        })
      );
    }

    const isFormValid = Object.keys(errors).length === 0;

    return isFormValid;
  };

  const goToStream = (streamDetails) => {
    history.push('/together', { streamDetails: streamDetails });
  };

  const setBrowserStorageFunc = (userDetails) => {
    setUserBrowserStorage('userDetails', JSON.stringify(userDetails));
    // setUserBrowserStorage('isLogin', 'false');
  };

  const sharedEventCall = async () => {
    try {
      const response = await Services.shared_event_call({
        userId: +eventAsGuest.userId,
        eventId: +eventAsGuest.eventId,
        eventUniqueNo: eventAsGuest.eventUniqueNo,
        seatId: +eventAsGuest.seatId,
        name: eventAsGuest.name.value,
        email: eventAsGuest.email.value,
        userStreamingUrlId: '1',
        userChatId: '1',
        paymentStatus: 'N',
      });
      if (response.data?.responseCode === 200) {
        if (response.data?.listOfHostEvents[0]['eventStatus'] === 'active') {
          setLoader(false);
          setBrowserStorageFunc(
            response.data.listOfHostEvents[0]['userDetails'][0]
          );
          goToStream(response.data.listOfHostEvents[0]);
          return;
        }
        toast.error('Event not started', { duration: 8000 });
        // return { eventStatus: 'Event not started', removeUserFromStream: true };
      } else {
        toast.error(response.data.details, { duration: 8000 });
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      toast.error('Please check your internet', { duration: 8000 });

      // return { eventStatus: 'Please check your internet' };
    }
  };

  const handleJoin = async () => {
    dispatch(clearEventId({}));

    if (validationFunc()) {
      setLoader(true);
      try {
        const res = await Services.passcode_email_check(
          eventAsGuest.email.value,
          eventId
        );
        if (res.data.responseCode === 200) {
          // toast.success(res.data.details, { duration: 6000 });
          dispatch(
            updateEventSeatInfo({
              info: {
                eventId: eventId,
                eventUniqueNo: eventUniqueNo,
                userId: res.data.userId,
                seatId: res.data.seatId,
              },
            })
          );
        }
      } catch (error) {
        setLoader(false);
      }
    }
  };

  return (
    <div>
      <CustomButton
        btnText='Watch Event As Guest'
        btnStyle={classes.btnStyleWatch}
        clickHandle={handleClickOpen}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='form-dialog-title'
      >
        <DialogTitle className={classes.titleDialog}>Watch Event</DialogTitle>
        <div
          style={{
            width: 560,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <DialogContent style={{ width: 420 }}>
            <DialogContentText>
              Please enter details to continue.
            </DialogContentText>

            <div className={classes.popOverContainer}>
              <TextFieldComp
                name='name'
                label='Full Name *'
                placeholder='Full Name'
                error={eventAsGuest.name.error}
                helpertext={eventAsGuest.name.helpertext}
                value={eventAsGuest.name.value}
                onChange={onChangeHandle}
                disabled={userDetails?.email && open}
                inputStyles={classes.inputStyles}
              />
              <TextFieldComp
                name='email'
                label='Email Address*'
                placeholder='Email Address'
                error={eventAsGuest.email.error}
                helpertext={eventAsGuest.email.helpertext}
                value={eventAsGuest.email.value}
                onChange={onChangeHandle}
                disabled={userDetails?.email && open}
                inputStyles={classes.inputStyles}
              />

              <TermsContainer
                termsContainer={classes.termsContainer}
                policyLink={classes.policyLink}
                termsText={classes.termsText}
                helpingText={watchAsGuestTermsText}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color='primary'>
              Cancel
            </Button>

            <CustomButton
              btnStyle={classes.btnStyleJoin}
              clickHandle={handleJoin}
              btnText={'Join'}
              endIcon={<ArrowRightAltSharpIcon className={classes.arrowIcon} />}
            />
          </DialogActions>
          {/* <div
          style={{
            width: 560,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <p style={{ alignSelf: 'flex-start' }}>Watch Event</p>
          <div style={{ display: 'flex' }}>



            
          </div> */}
        </div>
      </Dialog>
      <Loader open={loader} />
    </div>
  );
}
